<template>
  <div class="monitor-dashbord">
    <div class="bord">
      <div class="graph-dash" ref="graphRef">2</div>

      <div class="monitor-info">
        <div class="workshop">
          <div class="blue-title">选择工厂-车间</div>
          <div class="querry-params">
            <el-select v-model="factory" placeholder="请选择工厂" class="factory" @change="factoryChange">
              <el-option
                v-for="(item, index) in factoryOptions"
                :key="`index${index}`"
                :value="item.value"
                :label="item.label"
              >
              </el-option>
            </el-select>
            <el-select v-model="workShop" placeholder="请选择车间" @change="shopChange">
              <el-option
                v-for="(item, index) in workShopList"
                :key="`index${index}`"
                :value="item.value"
                :label="item.label"
              >
              </el-option>
            </el-select>
          </div>

          <div class="infors">
            <div v-for="(item, infoIndex) in bizDevices" :key="`index${infoIndex}`" class="info-item">
              <div :class="['infoImg', `infoImg${item.dictValue}`]"></div>
              <div class="label">{{ item.dictLabel }}</div>
            </div>
          </div>

          <div class="enum-status">
            <div
              :class="['status', `status${statusItme.value}`]"
              v-for="(statusItme, itemIndex) in statusEnum"
              :key="`itemIndex${itemIndex}`"
            >
              <span>{{ statusItme.key }} ：</span>
              <span>{{ statusItme.label }}</span>
            </div>
          </div>
        </div>

        <div class="monitor-detail">
          <div class="blue-title">
            <span>场景监控数据详情</span>
          </div>
          <div class="sub-title">显示场景：{{ curcellInfo?.sceneName }}</div>

          <div class="details">
            <template v-for="(item, index) in curcellInfo?.scenePointInfoList">
              <!-- 只展示有设备的 -->
              <div v-if="item.deviceId" :key="`index${index}`" class="info-item">
                <div :class="['detailImg', `infoImg${item?.pointType}`]"></div>
                <div v-if="item.deviceData" :key="item.id" class="iteminfos">
                  <div v-for="(val, valIndex) in item?.deviceData.data" :key="`index${valIndex}`">
                    <span>{{ val.name }}:</span>
                    <span>{{ val.value || '--' }}</span>
                  </div>
                </div>

                <!-- <div class="label">{{ item.deviceName }}</div> -->
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频监控区域 -->
    <div class="video-section">
      <div class="section-title">车间实时监控画面</div>
      <div class="video-grid video">
        <div v-for="(item, index) in cameras" :key="`index${index}`" class="video-item item">
          <div class="video-title">镜头{{ index + 1 }} - {{ item.name }}</div>
          <div class="video-player-container" @click="togglePlay(item)">
            <video ref="videoPlayer" :id="'videoElement' + index" class="video-player" playsinline></video>

            <!-- 简化后的控制条 -->
            <div class="player-controls">
              <button class="control-btn" @click.stop="togglePlay(item)">
                {{ item.playing ? '❚❚' : '▶' }}
              </button>

              <div class="play-tools">
                <button class="control-btn fullscreen-btn" @click.stop="toggleFullscreen(item)">⛶</button>
                <!-- 垂直音量控制条 -->
                <div class="volume-control-wrapper">
                  <div class="vertical-volume-container">
                    <div class="volume-icon" @click.stop="toggleMute(item)">
                      {{ item.muted ? '🔇' : '🔊' }}
                    </div>
                    <input
                      type="range"
                      min="0"
                      max="1"
                      step="0.1"
                      v-model="item.volume"
                      @click.stop
                      @input="changeVolume(item, $event)"
                      class="vertical-volume-slider"
                      orient="vertical"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Graph } from '@antv/x6';
import { Selection } from '@antv/x6-plugin-selection';
import request from '@/utils/request';
import api from '@/utils/api';

import mpegtsjs from 'mpegts.js';

import { mapState } from 'vuex';

export default {
  data() {
    return {
      graph: null,
      infos: [1, 2, 3, 4, 5, 6, 7],
      factory: '',
      workShop: '',
      factoryOptions: [],
      workShopList: [],
      detailsInfos: [
        {
          label: '压差：66pa',
          code: 1
        },
        {
          label: '图像正常',
          code: 2
        },
        {
          label: '空气粒子数',
          infos: ['0.3μm：1000', '0.5μm：700', '1.0μm：600', '3.0μm：500', '5.0μm：200'],
          code: 3
        },
        {
          label: '臭氧浓度',
          code: 4
        }
      ],
      sceneJson: {},
      curCell: null,
      bizDevices: [],
      cameras: [
        // {
        //   name: '入口监控',
        //   src: 'http://139.9.219.170:38080/live/camera2025062201.flv',
        //   playing: false,
        //   muted: false,
        //   volume: 1,
        //   player: null
        // },
        // {
        //   name: '生产线监控',
        //   src: 'http://139.9.219.170:38080/live/camera2025062201.flv',
        //   playing: false,
        //   muted: false,
        //   volume: 1,
        //   player: null
        // }
      ],
      curcellInfo: null,
      statusEnum: {
        1: {
          key: '绿色',
          label: '正常',
          color: '#1ecb80',
          value: '1'
        },
        2: {
          key: '红色',
          label: '报警',
          color: '#ff8686',
          value: '2'
        },
        3: {
          key: '灰色',
          label: '掉线',
          color: '#898989',
          value: '3'
        }
      },
      player: null
    };
  },
  computed: {
    ...mapState('login', ['tenantId']) // 'auth' 是你的模块名称，根据实际情况调整
  },
  mounted() {
    this.initGraph();
    this.getFactoryList();
    this.getBizSceneType();
  },
  watch: {
    // 当isFlod变化时，这个函数就会被调用
    curCell(newValue, oldValue) {
      if (newValue?.id !== oldValue?.id) {
        const found = this.workshopSceneLayoutData.find((scene) => scene.cellId === newValue?.id);
        if (found) {
          this.curcellInfo = found;
          if (found.scenePointInfoList.length) {
            this.cameras =
              found.scenePointInfoList
                .filter((item) => item.pointType === 1 && item.deviceId)
                .map((item) => {
                  return {
                    name: item.deviceName,
                    src: '',
                    deviceNum: item.deviceNum,
                    playing: false,
                    muted: false,
                    volume: 1,
                    player: null
                  };
                }) || [];
            this.initVideoPlayers();
          } else {
            this.cameras = [];
          }
        }
      }
    }
  },
  methods: {
    createPlayer(url) {
      if (mpegtsjs.isSupported()) {
        //判断浏览器是否支持播放
        if (this.player) {
          this.destory();
        }
        this.player = mpegtsjs.createPlayer(
          //创建一个播放器实例
          {
            type: 'flv', //播放的格式 flv mp4 ts mse等
            url,
            isLive: true, //指示数据源是否为直播流
            isAutoPlay: true, //是否自动播放
            isContinue: true, //是否循环播放
            lazyLoad: true, //如果有足够的数据进行播放，则终止http连接
            hasAudio: false //声音关闭，如果传来的视频流没有声音，就一定要设置这个参数，否则会报错
          },
          {
            enableWorker: true, //是否启用分离线程
            enableStashBuffer: false, //是否关闭IO隐藏缓冲区
            stashInitialSize: 128 //IO存储缓冲区初始大小，默认为384kb
          }
        );

        this.player.attachMediaElement(this.$refs.videoPlayer); //将播放器注册到Video节点
        this.player.load(); //加载
        setTimeout(() => {
          this.player
            .play()
            .then(() => {
              console.log('播放');
            })
            .catch((err) => {
              console.log('err', err);
            });
        });
      }
    },
    // 初始化视频播放器
    initVideoPlayers() {
      this.cameras.forEach((camera, index) => {
        if (mpegtsjs.getFeatureList().mseLivePlayback) {
          const videoElement = document.getElementById(`videoElement${index}`);
          if (videoElement) {
            camera.player = mpegtsjs.createPlayer({
              type: 'mse',
              isLive: true,
              url: camera.src
            });

            camera.player.attachMediaElement(videoElement);
            camera.player.load();
            // camera.player.play();
            setTimeout(() => {
              camera.player.play();
            }, 500);
          }
        }
      });
    },
    // 切换播放/暂停
    async togglePlay(camera) {
      console.log(555);
      const index = this.cameras.indexOf(camera);
      const videoElement = document.getElementById(`videoElement${index}`);

      if (camera.deviceNum) {
        // 首次播放，先获取URL
        const url = await this.getVideoUrl(camera.deviceNum);
        if (!url) return;

        this.initVideoPlayers(camera, url);
      }

      // 切换播放状态
      if (camera.playing) {
        camera.player.pause();
      } else {
        camera.player.play();
      }
      camera.playing = !camera.playing;
    },
    // 获取视频URL
    async getVideoUrl(deviceNum) {
      try {
        const res = await request.post(`${api.monitorDashbord.getMonitVideoUrl}`, { devNum: deviceNum });
        if (res.code === 200) {
          return res?.data?.playUrl || ''; // 返回视频URL
        }
      } catch (error) {
        this.$message.error('获取视频流地址失败');
      }
      return '';
    },
    // 切换静音
    toggleMute(camera) {
      const videoElement = this.$refs.videoPlayer.find((el) => el.id === `videoElement${this.cameras.indexOf(camera)}`);
      if (videoElement) {
        videoElement.muted = !videoElement.muted;
        camera.muted = videoElement.muted;
        // 如果取消静音，恢复之前音量
        if (!videoElement.muted) {
          videoElement.volume = camera.volume;
        }
      }
    },
    // 调整音量
    changeVolume(camera, event) {
      const videoElement = this.$refs.videoPlayer.find((el) => el.id === `videoElement${this.cameras.indexOf(camera)}`);
      if (videoElement) {
        const newVolume = parseFloat(event.target.value);
        videoElement.volume = newVolume;
        camera.volume = newVolume;
        // 如果调整音量，自动取消静音
        if (newVolume > 0 && camera.muted) {
          videoElement.muted = false;
          camera.muted = false;
        }
      }
    },
    // 切换全屏
    toggleFullscreen(camera) {
      const videoContainer = this.$el.querySelector(`#videoElement${this.cameras.indexOf(camera)}`).parentElement;
      if (!document.fullscreenElement) {
        if (videoContainer.requestFullscreen) {
          videoContainer.requestFullscreen();
        } else if (videoContainer.mozRequestFullScreen) {
          videoContainer.mozRequestFullScreen();
        } else if (videoContainer.webkitRequestFullscreen) {
          videoContainer.webkitRequestFullscreen();
        } else if (videoContainer.msRequestFullscreen) {
          videoContainer.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },
    // 获取场景类型
    getBizSceneType() {
      request
        .get(`${api.pointManagement.getBizDeviceName}`)
        .then((res) => {
          if (res.code === 200) {
            this.bizDevices = (res.data || []).map((item) => {
              return {
                dictCode: item.dictCode,
                dictLabel: item.dictLabel,
                dictValue: item.dictValue
              };
            });
          } else {
            this.bizDevices = [];
          }
        })
        .catch((err) => {
          this.bizDevices = [];
        });
    },
    factoryChange() {
      this.workShop = '';
      this.getWorkShopList();
    },
    shopChange() {
      this.getSceneLayout();
    },
    // 查询车间
    getWorkShopList() {
      request
        .get(`${api.dropdownList.workshopList}`, {
          params: {
            // 这是 GET 请求的标准传参方式
            factoryId: this.factory
          }
        })
        .then((res) => {
          if (res.code === 200 && res?.data?.length) {
            this.workShopList = (res.data || []).map((item) => {
              return {
                label: item.name,
                value: item.id
              };
            });
            if (this.workShopList.length) {
              this.workShop = this.workShopList[0].value;
              this.getSceneLayout();
            }
          } else {
            this.workshopOptions = [];
          }
        })
        .catch((err) => {
          this.workshopOptions = [];
        });
    },
    // 查询工厂
    getFactoryList() {
      request
        .get(`${api.dropdownList.factoryList}`, {
          params: {
            tenantId: '00'
          }
        })
        .then((res) => {
          if (res.code === 200 && res?.data?.length) {
            this.factoryOptions = (res.data || []).map((item) => {
              return {
                label: item.name,
                value: item.id
              };
            });

            if (this.factoryOptions.length) {
              this.factory = this.factoryOptions[0].value;
              this.getWorkShopList();
            }
          } else {
            this.factoryOptions = [];
          }
        })
        .catch((err) => {
          this.factoryOptions = [];
        });
    },
    initGraph() {
      this.graph = new Graph({
        container: this.$refs.graphRef,

        panning: {
          // 禁用画布拖拽
          enabled: false // 关闭画布平移
        },
        interacting: {
          // 控制交互行为
          nodeMovable: false,
          stopScrollOnTouchStart: false
        },
        mousewheel: {
          enabled: false, // 启用滚轮缩放
          zoomAtMousePosition: false, // 以鼠标位置为中心缩放
          modifiers: [], // 无需按修饰键（默认需要按ctrl）
          minScale: 0.5, // 最小缩放比例
          maxScale: 3, // 最大缩放比例
          zoomFactor: 0.1 // 缩放速度
        },
        background: {
          color: '#F2F7FA'
        }
      });

      this.graph.use(
        new Selection({
          enabled: true, // 开启选择功能
          movable: false, // 在选择插件中禁用移动
          rubberband: false, // 启用框选
          multiple: false, // 允许多选（按住 Ctrl/Cmd）
          movable: false, // 选中节点可拖动
          strict: false, // 框选时部分重叠即选中（true 需完全包含）
          showNodeSelectionBox: false, // 显示节点选中框
          className: 'my-selecting',
          pointerEvents: 'none' // 避免遮挡事件:cite[7]:cite[10]
        })
      );

      // this.graph.on('cell:click', this.cellFn);

      this.graph.on('node:selected', ({ node }) => {
        // 设置选中样式

        if (node.isNode() && node.getData().isParent) {
          // 父节点选中
          node.attr('body/fill', '#366bfc');

          node.attr('body/stroke', '#366bfc');
          this.curCell = node;
        }

        if (node.isNode() && node.getParent()) {
          const parentNode = node.getParent();
          this.curCell = parentNode;
          parentNode.attr('body/fill', '#366bfc');

          parentNode.attr('body/stroke', '#366bfc');
        }
      });

      this.graph.on('node:unselected', ({ node }) => {
        if (this.curCell === node) {
          this.curCell = null;
        }
        // 从节点数据获取原始样式
        if (node.isNode() && node.getData().isParent) {
          const originalStyle = node.getData()?.originalStyle;
          if (originalStyle) {
            node.attr('body/fill', originalStyle.fill);
            node.attr('body/stroke', originalStyle.stroke);
          } else {
            // 默认恢复样式
            node.attr('body/fill', '#FFFFFF');
            node.attr('body/stroke', '#595959');
          }
        }

        if (node.isNode() && node.getParent()) {
          const parentNode = node.getParent();
          const originalStyle = parentNode.getData()?.originalStyle;

          if (originalStyle) {
            parentNode.attr('body/fill', originalStyle.fill);
            parentNode.attr('body/stroke', originalStyle.stroke);
          } else {
            // 默认恢复样式
            parentNode.attr('body/fill', '#FFFFFF');
            parentNode.attr('body/stroke', '#595959');
          }
        }
      });

      this.graph.on('blank:click', () => {
        // 清空选中

        // this.graph.cleanSelection();

        // 清空当前节点引用

        this.curCell = null;
      });
    },
    cellFn({ e, cell }) {
      e.stopPropagation();

      // 更新当前选中节点
      this.curCell = cell;
    },
    // 获取场景图
    getSceneLayout() {
      request
        .get(`${api.monitorDashbord.getWorkShopLayout}/${this.workShop}`)
        .then((res) => {
          if (res.code === 200) {
            const { workshopSceneLayoutData, workshopSceneLayoutJsonStr } = res.data;
            if (workshopSceneLayoutData) {
              this.sceneJson = JSON.parse(workshopSceneLayoutJsonStr);
              this.workshopSceneLayoutData = workshopSceneLayoutData || [];
              const cells = this.sceneJson.cells;

              if (this.graph && cells.length) {
                for (let i = 0; i < cells.length; i++) {
                  let cell = cells[i];

                  for (let i = 0; i < this.workshopSceneLayoutData.length; i++) {
                    let scene = this.workshopSceneLayoutData[i];
                    if (scene.scenePointInfoList.length) {
                      for (let j = 0; j < scene.scenePointInfoList.length; j++) {
                        let point = scene.scenePointInfoList[j];
                        let fondPointCell = cells.find((cell) => point.cellId === cell.id);
                        if (fondPointCell) {
                          fondPointCell.data = point;
                        }
                      }
                    }
                  }
                }
              }

              this.graph.fromJSON(this.sceneJson); // 渲染元素
              const nodes = this.graph.getNodes();
              // 更新节点样式
              this.updataNodesStyle(nodes);
              this.graph.centerContent(); // 居中显示
              this.zoomToFit();

              // 渲染后，找到第一个父节点并选
              let firstParentNode = null;
              for (let i = 0; i < nodes.length; i++) {
                const node = nodes[i];
                if (node.isNode() && node.getData().isParent) {
                  firstParentNode = node;
                  break;
                }
              }

              if (firstParentNode) {
                // 选中该节点
                this.graph.select(firstParentNode);
              }
            } else {
              this.sceneJson = {};
              this.graph.fromJSON(this.sceneJson); // 渲染元素
            }
          } else {
            this.sceneJson = {};
            this.graph.fromJSON(this.sceneJson); // 渲染元素
          }
        })
        .catch((err) => {
          this.sceneJson = {};
          this.graph.fromJSON(this.sceneJson); // 渲染元素
        });
    },
    // 更行节点样式
    // 更新节点样式
    updataNodesStyle(nodes) {
      let danger = '#ff8686';
      let health = '#1ecb80';
      let leave = '#898989';
      let noDeviceColor = '#8f8f8f'; // 没有设备的颜色
      let deviceColor = '#7719aa'; // 绑定设备的颜色
      nodes.forEach((node) => {
        // 3. 检查是否为节点（现在使用正确的图形对象）
        if (node.isNode()) {
          // 如果是节点且是子节点，查询
          if (node.isNode() && node.getParent()) {
            const data = node.getData();

            if (data.pointId && data?.deviceId && data?.deviceData?.status === 1) {
              node.attr('body/fill', health);
              node.attr('body/stroke', this.health);
            } else if (data.pointId && data?.deviceId && data?.deviceData?.status === 2) {
              node.attr('body/fill', danger);
              node.attr('body/stroke', danger);
            } else if (data.pointId && data?.deviceId && data?.deviceData?.status === 3) {
              node.attr('body/fill', leave);
              node.attr('body/stroke', leave);
            } else if (data.pointId && data?.deviceId && !data?.deviceData?.status) {
              // 绑定了设备 没有设备状态
              node.attr('body/fill', leave);
              node.attr('body/stroke', leave);
            } else {
              // 没有绑定设备 清除设备
              // node.attr('body/fill', noDeviceColor);
              // node.attr('body/stroke', noDeviceColor);
              this.graph.removeNode(node);
            }
          }
        }
      });
    },
    zoomToFit() {
      this.graph.zoomToFit({
        padding: 40,
        maxScale: 100,
        minScale: 0.5,
        allowNewOrigin: 'any',
        contentArea: true,
        useCellGeometry: true
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.monitor-dashbord {
  height: calc(100vh - 40px);
  overflow: auto;
  .title-box {
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    padding: 27px 0 15px;
    line-height: 16px;
  }

  .blue-title {
    padding-bottom: 15px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 2px;
    &::before {
      content: '';
      display: block;
      width: 3px;
      height: 17px;
      background-color: #3083fb;
      margin-right: 4px;
    }
  }

  .monitor-info {
    width: 400px;
  }
  .bord {
    margin-top: 10px;
    display: flex;
    height: 640px;
    .workshop {
      padding: 10px;
      margin-bottom: 18px;
      width: 100%;
      background: #f2f8ff;
      border-radius: 8px;
      box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.1);

      .querry-params {
        margin-top: 19px;
        display: flex;
        flex-wrap: nowrap;
      }

      .el-select {
        width: calc((100% - 10px) / 2);
        margin-bottom: 10px;

        &:nth-child(1) {
          margin-right: 10px;
        }
      }

      .infors {
        display: flex;
        flex-wrap: wrap;
        .info-item {
          width: calc((100% - 10px) / 2);
          display: flex;
          justify-content: flex-start;
          padding: 6px 0;
          &:nth-child(2n + 1) {
            margin-right: 10px;
          }

          .infoImg {
            width: 20px;
            height: 20px;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin-right: 20px;
            &.infoImg2 {
              background-image: url('@/assets/images/point-pressure-blue.svg');
            }
            &.infoImg1 {
              background-image: url('@/assets/images/point-camera--blue.svg');
            }
            &.infoImg3 {
              background-image: url('@/assets/images/point-air-particles-blue.svg');
            }
            &.infoImg5 {
              background-image: url('@/assets/images/point-Temperature-blue.svg');
            }
            &.infoImg4 {
              background-image: url('@/assets/images/ponit-ozone-concentration-blue.svg');
            }
          }

          .label {
            text-align: left;
          }
        }
      }

      .enum-status {
        margin: 10px 0;
        line-height: 22px;
        font-weight: bold;

        .status1 {
          color: #1ecb80;
        }
        .status2 {
          color: #ff8686;
        }
        .status3 {
          color: #898989;
        }
      }
    }
    .graph-dash {
      flex: 1;
      height: 100%;
      border: 1px solid #ccc;
      margin-right: 10px;
      border-radius: 8px;
    }

    .monitor-detail {
      width: 100%;
      height: calc(100% - 320px);
      padding: 10px;
      background: #f5fff9;
      box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;

      .title {
        font-size: 16px;
        font-weight: bold;
        text-align: left;
      }

      .sub-title {
        font-size: 14px;
        padding: 8px 0;
      }

      .details {
        .info-item {
          display: flex;
          justify-content: flex-start;
          margin: 8px 0;

          .detailImg {
            width: 20px;
            height: 20px;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin-right: 20px;
            &.infoImg2 {
              background-image: url('@/assets/images/point-pressure-blue.svg');
            }
            &.infoImg1 {
              background-image: url('@/assets/images/point-camera--blue.svg');
            }
            &.infoImg3 {
              background-image: url('@/assets/images/point-air-particles-blue.svg');
            }
            &.infoImg5 {
              background-image: url('@/assets/images/point-Temperature-blue.svg');
            }
            &.infoImg4 {
              background-image: url('@/assets/images/ponit-ozone-concentration-blue.svg');
            }
          }

          .iteminfos {
            padding: 0 20px 0 54px;
          }
        }
      }
    }
  }

  .video-section {
    padding: 10px 0;
    .section-title {
      padding: 10px;
      font-weight: bold;
    }
  }

  .video-grid {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: flex-start;

    .video-title {
      height: 40px;
      padding: 10px;
      text-align: left;
      width: 100%;
      background-color: #4f5566;
      color: #fff;
    }

    .video-item {
      height: 380px;
      width: calc((100% - 20px) / 3);
      border: 1px solid #ccc;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      margin-bottom: 10px;
      margin-right: 10px;

      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }

  .video-player-container {
    position: relative;
    width: 100%;
    height: 339px;
    cursor: pointer;
    background: #000;
    overflow: hidden;

    &:hover {
      .volume-control-wrapper {
        opacity: 1;
      }

      .player-controls {
        opacity: 1;
      }
    }
  }

  .video-player {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .vertical-volume-container {
    display: flex;
    align-items: flex-end;
    padding: 8px 5px;
    border-radius: 20px;
    position: relative;
    height: 120px; /* 固定高度 */

    &:hover {
      .vertical-volume-slider {
        opacity: 1;
      }
    }
  }

  .volume-icon {
    color: white;
    font-size: 20px;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      transform: scale(1.1);
    }
  }

  .vertical-volume-slider {
    -webkit-appearance: none;
    width: 6px;
    height: 100px;
    background: linear-gradient(to top, #4a90e2, #1ecb80); /* 渐变轨道，从下到上 */
    border-radius: 3px;
    outline: none;
    opacity: 0;
    transform: rotate(0deg); /* 不需要旋转180度了 */
    writing-mode: bt-lr;
    -webkit-appearance: slider-vertical;
    margin-left: 10px;
    margin-bottom: 6px;

    /* 滑块手柄样式 */
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: white;
      cursor: pointer;
      margin-top: -8px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.2);
      }
    }
  }

  .control-btn {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 16px;
    margin: 0 15px;
    padding: 5px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    transition: background 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }

    &.fullscreen-btn {
      margin-right: 68px;
    }
  }

  .player-controls {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    opacity: 0;
    padding: 10px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    transition: opacity 0.3s;
    z-index: 10;

    .play-tools {
      display: flex;
      align-items: center;
      position: relative;

      /* 垂直音量控制区域 */
      .volume-control-wrapper {
        margin-right: 10px;
        position: absolute;
        right: 0;
        top: -80px;
        transition: opacity 0.3s;

        &:hover {
          opacity: 1;
        }
      }
    }
  }
}

.box {
  width: 300px;
  height: 300px;
  .video-player-test {
    width: 100%;
    height: 100%;
  }
}
</style>
